<template>
<div>
    <div class="container-fluid bg-white" id="header">
      <div class="row">
        <div class="col d-flex align-items-center"><img class="my-1" v-show="location.office.logo" :src="location.office.logo" alt="Agency Logo" height="66px" />
          <h2 class="ml-2 mb-0 problue agency-name">{{ location.agencyName }}</h2>
        </div>
        <div class="col-sm-12 col-md-8">
          <div class="row justify-content-end align-items-center no-gutters" id="user_info">
            <div class="col-auto m-2"><span class="problue font-weight-bold">Welcome:</span><span class="text-success ml-1 am-header">{{ user.name }}</span></div>
            <div class="col-auto mr-2 my-2"><span class="problue pl-2 font-weight-bold">Office (Off):<old-link class="ml-2 font-weight-normal am-header" :to="`#/office/view/${location.office.id}`">{{ location.office.name }}</old-link></span></div>
            <div class="col-auto mr-2 my-2"><span class="pl-2"><old-link to="#/settings" class="am-header">Settings</old-link></span></div>
            <div class="col-auto mr-2 my-2"><span class="pl-2"><old-link to="/logout.php" class="am-header">Logout</old-link></span></div>
          </div>
          <div class="row justify-content-end align-items-center no-gutters">
              <div v-if="$store.state.auth.telephony.telephonySubAccount === 1 && $store.state.auth.telephony.whereAmI !== 'None' ">
                <telephony></telephony>
              </div>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<ClockIn></ClockIn>
          </div>

          <div class="row justify-content-end align-items-center no-gutters">
            <div class="col-auto mr-1 my-1">
                <oldLink class="btn btn-sm btn-warning referral-program-link header-button" to="#/referral_program"><span>
                  <font-awesome-icon icon="user-md"></font-awesome-icon></span> Refer a Friend</oldLink>
            </div>
            <div class="col-auto mr-1 my-1">
                <oldLink class="btn btn-sm btn-warning am-marketplace-link header-button" to="#/market_place"><span>
                  <font-awesome-icon icon="crosshairs"></font-awesome-icon></span> Market Place</oldLink>
            </div>
            <div class="col-auto mr-1 my-1" v-if="$store.state.auth.config.isReceiveLeads">
                <oldLink class="btn btn-sm btn-blue am-btn-primary header-button" to="/leadEdit.php?id=0">Add Lead</oldLink>
            </div>
            <div class="col-auto mr-1 my-1"><a class="btn btn-sm am-btn-primary btn-blue header-button" href="https://www.agencymatrix.com/blog">Blog</a></div>
            <div class="col-auto mr-1 my-1">
                <oldLink class="btn btn-sm am-btn-primary btn-blue header-button" to="/customerEdit.php?id=0">Add {{$store.state.auth.whiteLabel.customer}}</oldLink>
            </div>
            <customer-search></customer-search>
          </div>
        </div>
      </div>
    </div>
</div>
</template>

<script>
import OldLink from './OldLink'
import CustomerSearch from './HeaderCustomerSearch'
import Telephony from './Telephony'
import ClockIn from './ClockIn'
export default {
  name: 'Headerbar',

  components: {
    ClockIn,
    Telephony,
    OldLink,
    CustomerSearch
  },

  props: {
    user: {
      type: Object,
      required: true
    },
    location: {
      type: Object,
      required: true
    }
  }
}
</script>

<style lang="sass">
  .problue
    font-size: 12px
  .bg-white
    line-height: 1
  #header
    border-top-width: 6px !important
  #user_info > div:not(:first-child) > span:first-child
    border-left: 1px solid
  .am-header
    color: #044e99
    font-variant: proportional-width
    font-weight: 500
    font-size: 12px
    font-family: Arial,Helvetica,sans-serif

  .header-button
    padding: 2px 5px
    font-size: 12px
    text-shadow: 0 -1px 0 rgba(0, 0, 0, 0.2)
    -webkit-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075)
    box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075)
    line-height: 1.3
    border-radius: 0px
    font-family: Arial,Helvetica,sans-serif
  .agency-name
    font-weight: 700
    margin-top: 12px
    margin-left: 20px!important
    font-size: 24px

</style>
